'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFullscreenNode = setFullscreenNode;
exports.setFullscreen = setFullscreen;
exports.toggleFullscreen = toggleFullscreen;

var _constants = require('../constants');

var _store = require('../../../store');

var _store2 = _interopRequireDefault(_store);

var _canUseDom = require('can-use-dom');

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * TODO: This file to be refactored once we know how fullscreen with multiple video
 * is going to work.. For now, despite playerId, it will only work for one player.
 */

var videoContainerNodes = {};
var exitHandler = void 0;

if (_canUseDom2.default) {
  document.exitFullscreen = document.exitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen;
}

function setFullscreenNode(playerId, _node) {
  videoContainerNodes[playerId] = _node;
}

function isFullScreen() {
  return !!document.fullScreenElement || !!document.msFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.msIsFullScreen || false;
}

function bindFullscreenEvents(playerId) {
  exitHandler = createExitHandler(playerId); // eslint-disable-line no-use-before-define
  document.addEventListener('mozfullscreenchange', exitHandler);
  document.addEventListener('webkitfullscreenchange', exitHandler);
  document.addEventListener('fullscreenchange', exitHandler);
  document.addEventListener('MSFullscreenChange', exitHandler);
}

function unbindFullscreenEvents() {
  document.removeEventListener('mozfullscreenchange', exitHandler);
  document.removeEventListener('webkitfullscreenchange', exitHandler);
  document.removeEventListener('fullscreenchange', exitHandler);
  document.removeEventListener('MSFullscreenChange', exitHandler);
}

function setFullscreen(playerId, fullscreen) {
  if (fullscreen) {
    bindFullscreenEvents(playerId);
  } else {
    unbindFullscreenEvents();
  }

  return {
    type: _constants.TOGGLE_FULLSCREEN,
    playerId: playerId,
    fullscreen: fullscreen
  };
}

function createExitHandler(playerId) {
  return function () {
    if (!isFullScreen()) {
      _store2.default.storeInstance().dispatch(setFullscreen(playerId, false));
      unbindFullscreenEvents();
    }
  };
}

function toggleFullscreen(playerId) {
  var videoContainerNode = videoContainerNodes[playerId];
  if (!videoContainerNode) {
    return {
      type: _constants.TOGGLE_FULLSCREEN_FAILED,
      playerId: playerId,
      message: 'No Video Container node has been set'
    };
  }

  videoContainerNode.requestFullscreen = videoContainerNode.requestFullscreen || videoContainerNode.msRequestFullscreen || videoContainerNode.mozRequestFullScreen || videoContainerNode.webkitRequestFullscreen;

  var fullscreen = _store2.default.storeInstance().getState().players[playerId].fullscreen;

  if (fullscreen) {
    document.exitFullscreen();
  } else {
    videoContainerNode.requestFullscreen();
    bindFullscreenEvents(playerId);
  }

  return {
    type: _constants.TOGGLE_FULLSCREEN,
    playerId: playerId,
    fullscreen: !fullscreen
  };
}